module.exports = __webpack_public_path__ + "50fd15c43a9a5f79cb6c10c155b75569.jpg";